import { gql } from '@apollo/client';

// Remittances list query
export const GET_REMITTANCES_LIST_QUERY = gql`
  query GetRemittancesList($studySiteInvestigatorId: UUID!, $limit: Int = 100, $offset: Int = 0) {
    remittances(studySiteInvestigatorId: $studySiteInvestigatorId, limit: $limit, offset: $offset) {
      edges {
        id
        remittanceNumber
        remittanceDate
        totalAmountMicros
        status
        lineItemCount
        createdAt
      }
      totalCount
    }
  }
`;

// Remittance detail query (with line items)
export const GET_REMITTANCE_QUERY = gql`
  query GetRemittance($id: UUID!) {
    remittance(id: $id) {
      id
      remittanceNumber
      remittanceDate
      totalAmountMicros
      currencyCode
      status
      documentId
      lineItems {
        id
        lineNumber
        patientNumber
        visitName
        activityDescription
        serviceDate
        amountMicros
        currencyCode
        adjustmentType
        adjustmentReason
      }
      createdAt
    }
  }
`;
